import { render } from "./RegionsConfigsLimits.vue?vue&type=template&id=a1562edc&scoped=true"
import script from "./RegionsConfigsLimits.vue?vue&type=script&lang=js"
export * from "./RegionsConfigsLimits.vue?vue&type=script&lang=js"

import "./RegionsConfigsLimits.vue?vue&type=style&index=0&id=a1562edc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a1562edc"]])

export default __exports__